import { styled, Theme } from '@mui/material'
import TextField from '@mui/material/TextField'

import { InputProps } from './types'

export const StyledInput = styled(TextField)<InputProps>`
  input {
    padding: ${({ inputstyle }) => (inputstyle === 'oc' ? '8.5px 0 8.5px 14.5px' : '12px')};
    border-color: ${({ theme }) => theme.palette.grey[200]};
    box-shadow: ${({ inputstyle }) =>
      inputstyle === 'oc' ? 'none' : '0 3px 4px -4px rgba(0, 0, 0, 0.25)'};
    font-size: ${({ inputstyle }) => (inputstyle === 'oc' ? 'inherit' : '14px')};
  }

  ${({ minwidth }) => (minwidth ? `min-width: ${minwidth}px;` : '')}

  ${({ width, type }): string | false =>
    type === 'number' &&
    `
      width: ${width || 100}%;
      [type="number"] {
        margin: 0;
        border-radius: 2px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      fieldset {
        display: none;
      }
      > p {
        position: absolute;
        top: 50px;
        left: -13px;
      }
    `}

  ${({ inputstyle }): string => {
    switch (inputstyle) {
      case 'dark':
        return `
          border-radius: 3px;
          background: ${({ theme }: { theme: Theme }) => theme.palette.grey[800]};
          border: none;
          fieldset {
              border: none;
          }
          input {
            color: ${({ theme }: { theme: Theme }) => theme.palette.grey[50]};
            border: none;

            ::placeholder {
              opacity: .7
            }

            &:hover {
              border: none;
            }
          }
      `
      default:
        return `
          background: ${({ theme }: { theme: Theme }) => theme.palette.background.paper};
        `
    }
  }}
`
